<template>
  <div class="cta-spotlight">
    <section class="section-container section-container-double-gap">
      <h2 class="section-container-heading">
        <p
          v-for="(line, index) in lines"
          :key="line.text"
          class="extra-large-text-list fade-up-animation"
          :class="{ 'special-text': line.special }">
          {{ line.text }}
        </p>
      </h2>

      <nuxt-link class="arrow-button arrow-button-bigger fade-up-animation" to="/#contact" aria-label="Let's go">
        <p class="heading-4-bold">Let's go</p>
        <div class="arrow-button-icon" v-html="[icons.rightArrowIcon, icons.rightArrowIcon]"></div
      ></nuxt-link>
    </section>
  </div>
</template>
<script setup>
import { useFadeUpObserver } from '@/composables/useFadeUpObserver';
import icons from '~/icons';

const lines = [
  { text: 'Ready to', special: false },
  { text: 'get started?', special: true },
];

useFadeUpObserver();
</script>
